<div *ngIf="environment.isB2E">
  <h2 class="title-lg">
    Vehicle Campaign Details (Internal view): {{dealerCode}}
  </h2>
</div>
<div *ngIf="environment.isB2D">
  <h2 class="title-lg">
    Vehicle Campaign Details (Dealer View): {{dealerCode}}
  </h2>
</div>
<br />
<div style="display: flex">
  <ds-box style="flex: 1">
    <ds-box-header class="title-lg">Selected Criteria</ds-box-header>
    <ds-box-content>
      <div class="row">
        <div class="row row-cols-1 row-cols-lg-2 gx-lg-5 gy-2 mb-1x">
          <div class="row">
            <p class="col mb-1x"><strong>Inventory:</strong> {{inventory}}</p>
          </div>
          <div class="row">
            <p class="col mb-1x">
              <strong>Defect Code:</strong> {{defectCodeDesc}}
            </p>
          </div>
          <div class="row">
            <p class="col mb-1x">
              <strong>Campaign Status:</strong> {{campaignStatus}}
            </p>
          </div>
          <div class="row">
            <p class="col mb-1x">
              <strong>Demo / Loaner Vehicle Count:</strong> {{demoLoanerCount}}
            </p>
          </div>
          <div class="row">
            <p class="col mb-1x"><strong>VIN Count:</strong> {{vinCount}}</p>
          </div>
        </div>
      </div>
    </ds-box-content>
  </ds-box>
</div>
<!-- table  -->
<br />
<div class="ag-theme-balham">
  <div content class="scroll-div">
    <div style="flex: 1">
      <ag-grid-angular
        class="grid-settings ag-theme-density zebra ag-theme-bmw ag-theme-balham grid-struct ag-theme-quartz grid-fixed-height"
        style="width: 100%"
        [style.height]="scrollHeight"
        [rowHeight]="rowHeight"
        [rowData]="rowData"
        [overlayNoRowsTemplate]="noRowsTemplate"
        [cacheBlockSize]="30"
        (selectionChanged)="onSelectionChanged()"
        [columnDefs]="columns"
        [pagination]="true"
        [rowSelection]="'multiple'"
        [theme]="theme"
        (rowClicked)="onRowClicked($event)"
        [paginationPageSize]="paginationPageSize"
        [paginationPageSizeSelector]="paginationPageSizeSelector"
        [rowBuffer]="50"
        [defaultColDef]="defaultColDef"
        [headerHeight]="headerHeight"
        (gridReady)="onGridReady($event)"
        [gridOptions]="gridOptions"
        (filterChanged)="onVCDFilterChanged()"
        (paginationChanged)="onPaginationChanged()"
        (firstDataRendered)="onFirstDataRendered()"
        (modelUpdated)="onModelUpdated()"
      >
      </ag-grid-angular>
      <br />
    </div>
    <ds-box class="actions-box">
      <div class="info-actions">
        <ds-button class="bck-btn me-3" ds-button-secondary (click)="goBack()"
          >Back</ds-button
        >
        <div>
          <button
            ds-button
            [ds-modal-trigger-for]="tpl"
            [disabled]="!isRowSelected"
            [(isModalOpen)]="modalIsOpen"
            (click)="notInInventory()"
          >
            Confirm- Not in inventory
          </button>
        </div>
        <ds-modal #tpl>
          <ds-box-header>User Comments</ds-box-header>
          <ds-box-content>
            <!-- <h4>Enter comments for exclude VINs</h4>
            <br>
            <textarea
              class="modal-textarea"
              rows="6"
              [attr.maxlength]="maxCommentLength"
              [value]="comment"
              #commentBox
              (input)="onCommentInput(commentBox.value)"
              placeholder="Enter your comments here..."
            ></textarea> -->
            <form
              [ds-form]="notInInventoryForm"
              [formGroup]="notInInventoryForm"
            >
              <ds-form-field ds-form-validation>
                <label ds-label for="myTextarea">
                  Enter comments for exclude VINs
                </label>
                <textarea
                  ds-input
                  id="myTextarea"
                  placeholder="Enter your comments here..."
                  [rows]="6"
                  formControlName="notInInventoryTextarea"
                  [ds-char-limit]="500"
                  maxlength="500"
                ></textarea>
                <ds-hint> Minimum number of characters: 7 </ds-hint>
                <!-- <ds-hint> Maximum number of characters: 500 </ds-hint> -->
                <ds-error
                  *ngIf="notInInventoryForm.controls['notInInventoryTextarea'].hasError('required') && (notInInventoryForm.controls['notInInventoryTextarea'].touched || formSubmitted)"
                >
                  This field is required.</ds-error
                >
                <ds-error
                  *ngIf="notInInventoryForm.controls['notInInventoryTextarea'].hasError('minlength') && (notInInventoryForm.controls['notInInventoryTextarea'].touched || formSubmitted)"
                >
                  Please enter at least 7 characters.
                </ds-error>
                <ds-error
                  *ngIf="notInInventoryForm.controls['notInInventoryTextarea'].hasError('maxlength') && (notInInventoryForm.controls['notInInventoryTextarea'].touched || formSubmitted)"
                >
                  Maximum character limit exceeded.
                </ds-error>
              </ds-form-field>
            </form>
          </ds-box-content>
          <ds-box-footer
            class="modal-footer-row"
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <h4>{{ remainingChars }} characters remaining.</h4>
            <button
              ds-button
              ds-button-primary
              ds-loading
              [isLoading]="isSubmitting"
              loadingVariant="indeterminate"
              type="button"
              [disabled]="!notInInventoryForm.valid"
              (click)="submitComments()"
            >
              Submit
            </button>
          </ds-box-footer>
        </ds-modal>
        <h3 class="export">Export:</h3>
        <ds-button
          tone="action"
          size="md"
          aria-label="Export PDF"
          (click)="downloadApiImplementation('pdf','total')"
        >
          <ds-icon icon="file_pdf" size="md" tone="action"></ds-icon>
        </ds-button>
        <ds-button
          tone="action"
          size="md"
          style="margin-right: 4px"
          aria-label="Export CSV"
          (click)="downloadApiImplementation('csv', 'total')"
        >
          <ds-icon icon="file_excel" size="md" tone="action"></ds-icon>
        </ds-button>
      </div>
    </ds-box>
  </div>
</div>
